import React from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { BadgeCounter } from 'components/designSystem/Badge/BadgeCounter'
import { ChatSvg } from 'components/designSystem/svgr/ChatSvg'
import { contactListPath } from 'components/paths'
import { useChatSelected } from 'components/presentational/Navigation/hooks/useChatSelected'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import {
  activeCss,
  Body,
  ChatLink,
  defaultCss,
  iconSizeCss,
} from '../TabBar/TabBar.styled'

export const Messenger = () => {
  const isSelected = useChatSelected()
  const { messagesCounter } = useShallowEqualSelector(
    ({ userReducer: { messagesCounter } }) => ({
      messagesCounter,
    })
  )

  return (
    <ChatLink
      to={contactListPath}
      className={cx(defaultCss, isSelected && activeCss)}
      data-name="messenger-action"
    >
      <Body>
        <ChatSvg className={cx(iconSizeCss)} />
        {messagesCounter > 0 && (
          <Badge counter={messagesCounter} data-name="messages-counter" />
        )}
      </Body>
    </ChatLink>
  )
}

const Badge = styled(BadgeCounter)`
  position: absolute;
  right: 50%;
  transform: translateX(100%);
  top: 5px;
`
